import { useState, useEffect, useContext, useMemo, useRef, forwardRef, useImperativeHandle } from "react";
import styles from './index.module.scss'
import PicModalLeft from './PicModalLeft'
import PicModalMiddle from './PicModalMiddle'
import PicModalRight from './PicModalRight'
import PicModalRightButton from './PicModalRightButton'
import PicModalFooter from './PicModalFooter'
import { BATCH_IMAGES_TYPE, IMAGE_TYPE } from "@utils/CONST";

const sortSucceededTasks = (tasks = []) => {
    const succeededTasks = (tasks || []).filter(task => task.status === 'succeeded')
    const isSmartDetailTask = succeededTasks.some(task => task?.projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH || task?.imageType === IMAGE_TYPE.SMART_DETAILA_PAGE)
    if (!isSmartDetailTask) return succeededTasks

    return succeededTasks
        .map((task, index) => ({ task, index }))
        .sort((a, b) => {
            const aSortIdx = Number(a?.task?.attr?.sortIdx ?? a?.task?.sortIdx)
            const bSortIdx = Number(b?.task?.attr?.sortIdx ?? b?.task?.sortIdx)
            const aValue = Number.isFinite(aSortIdx) ? aSortIdx : Number.MAX_SAFE_INTEGER
            const bValue = Number.isFinite(bSortIdx) ? bSortIdx : Number.MAX_SAFE_INTEGER
            if (aValue !== bValue) return aValue - bValue
            return a.index - b.index
        })
        .map(({ task }) => task)
}


const PictureViewModal = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
    }))
    const { groupedTasks, isModalOpen, setIsModalOpen, item, setItem, taskId, setTaskId, modalOpenFlag, displayType } = props
    const [selectedInputImg, setSelectedInputImg] = useState()
    const [currentViewIsHD, setCurrentViewIsHD] = useState(false)

    const onCancel = () => {
        setTaskId()
        setItem()
        setSelectedInputImg()
        setCurrentViewIsHD(false)
        setIsModalOpen(false)
        setCurrentIndex(null)
    }

    const [currentIndex, setCurrentIndex] = useState(null)

    useEffect(() => {
        if (!taskId || groupedTasks.length == 0) {
            onCancel()
            return
        }

        const flatTasks = sortSucceededTasks(groupedTasks?.flat())

        const index = flatTasks.findIndex(t => t.taskId === taskId)

        if (index !== -1) {
            // 找到当前项
            setCurrentIndex(index);
            const newItem = flatTasks[index];
            if (JSON.stringify(newItem) !== JSON.stringify(item)) {
                setItem(newItem);
            }
        } else {
            // 删除后，找不到 taskId 对应项
            const total = flatTasks.length
            if (total === 0) {
                setIsModalOpen(false)
                return;
            }

            let newIndex = null;
            if (currentIndex !== null) {
                // 尝试取删除前的 index
                if (currentIndex >= flatTasks.length) {
                    // 如果删的是最后一项，则取第一项
                    newIndex = 0
                } else {
                    // 否则取原 index 位置（即删除项的下一项）
                    newIndex = currentIndex
                }
            }

            const item = flatTasks[newIndex]
            setCurrentIndex(newIndex)
            setItem(item)
            setTaskId(item?.taskId)
        }
    }, [groupedTasks, taskId])

    useEffect(() => {
        if (!item) return
        setSelectedInputImg(item?.inputImages?.filter(i => i?.mainImage)?.[0]?.url)
        setCurrentViewIsHD(item?.results?.[0]?.hdImage ? true : false)
    }, [item])

    useEffect(() => {
        if (!isModalOpen) {
            setItem()
            setTaskId()
            setSelectedInputImg()
        }
    }, [isModalOpen])

    useEffect(() => {
        if (!taskId || !item || !selectedInputImg) return
        setIsModalOpen(true)
    }, [taskId, item, selectedInputImg])

    return (
        <div className={styles.PictureViewModal}>
            <div className={styles.modalContent}>
                <PicModalLeft
                    item={item}
                    onCancel={() => {
                        setIsModalOpen(false)
                    }}
                    fetchProjectDetail={props.fetchProjectDetail}
                    selectedInputImg={selectedInputImg}
                    setSelectedInputImg={setSelectedInputImg} />
                {
                    modalOpenFlag && <>
                        <div className={styles.PicModalMiddleWrap}>
                            <PicModalMiddle
                                item={item}
                                setProjectId={props.setProjectId}
                                displayType={displayType}
                                rawTasks={groupedTasks?.flat()}
                                currentViewIsHD={currentViewIsHD}
                                fetchProjectDetail={props.fetchProjectDetail}
                                selectedInputImg={selectedInputImg} />
                            <PicModalFooter
                                isSelectPage={props.isSelectPage}
                                regenerateByTaskId={props.regenerateByTaskId} // 重新生成
                                reEditClick={props.reEditClick} // 重新编辑
                                handleChoose={props.handleChoose} // 选择图片
                                item={item}
                                fetchProjectDetail={props.fetchProjectDetail}
                                currentViewIsHD={currentViewIsHD}
                                setCurrentViewIsHD={setCurrentViewIsHD}
                                onCancel={onCancel}
                            />
                        </div>
                        <PicModalRightButton
                            item={item}
                            isSelectPage={props.isSelectPage}
                            reEditClick={props.reEditClick}
                            regenerateByTaskId={props.regenerateByTaskId}
                            onCancel={onCancel}
                            fetchProjectDetail={props.fetchProjectDetail}
                            onOpenMaterialEdit={props.onOpenMaterialEdit}
                        />
                        <PicModalRight
                            taskId={taskId}
                            setTaskId={setTaskId}
                            groupedTasks={groupedTasks} />
                    </>
                }
            </div>

        </div>
    )
})

export default PictureViewModal
